export default __webpack_public_path__ + "static/media/portrait.7294cdb1.png";